import dayjs from "../../../../../configs/dayjs";
import { useCallback, useMemo } from "react";
import { KPI_CODES } from "../../../kpiCodes";
import { useXAxisFormat } from "../../../hooks/useXAxisFormat";
import { useFetchDataForTwoLines } from "../../../hooks/useFetchDataForTwoLines";

export const useFetchData = (isRecalculated: boolean, granularity: number) => {
  const { xAxisFormat, tooltipFormat } = useXAxisFormat(granularity);

  const getFormattedItem = useCallback(
    (item: any, kpi: any) => {
      const isAll: boolean = item.code === KPI_CODES.IMPOUNDS_TOTAL_BALANCE;

      return {
        month: dayjs(kpi.createdAt).format(xAxisFormat),
        type: isAll ? "All" : "Closed",
        value: kpi.value,
        tooltipValue: dayjs(kpi.createdAt).format(tooltipFormat),
        isMain: isAll,
      };
    },
    [tooltipFormat, xAxisFormat],
  );

  const kpiCodes: string[] = useMemo(
    () => [KPI_CODES.IMPOUNDS_TOTAL_BALANCE, KPI_CODES.IMPOUNDS_CLOSED_BALANCE],
    [],
  );

  const { data, isLoading } = useFetchDataForTwoLines(
    granularity,
    isRecalculated,
    kpiCodes,
    getFormattedItem,
  );

  return { data, isLoading };
};
